<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-top: 5px;">
      <el-tabs v-model="active">
        <el-tab-pane :label="$t('maintenance.errorLog')" name="log">
          <ele-pro-table
            ref="logTable"
            :datasource="logUrl"
            :columns="logColumns"
            :need-page="false"
            height="calc(100vh - 280px)"
            :toolkit="['reload']">
            <template slot="toolbar">
              <el-button
                size="small"
                type="danger"
                icon="el-icon-delete"
                class="ele-btn-icon"
                :loading="logClearing"
                @click="clearLogs('error')">
                {{ $t('maintenance.clearLog') }}
              </el-button>
            </template>
            <template slot="content" slot-scope="{ row }">
              <pre class="log-content-pre">{{ row.content }}</pre>
            </template>
          </ele-pro-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('maintenance.paymentLog')" name="payment">
          <ele-pro-table
            ref="paymentLogTable"
            :datasource="paymentLogUrl"
            :columns="logColumns"
            :need-page="false"
            height="calc(100vh - 280px)"
            :toolkit="['reload']">
            <template slot="toolbar">
              <el-button
                size="small"
                type="danger"
                icon="el-icon-delete"
                class="ele-btn-icon"
                :loading="paymentLogClearing"
                @click="clearLogs('payment')">
                {{ $t('maintenance.clearPaymentLog') }}
              </el-button>
            </template>
            <template slot="content" slot-scope="{ row }">
              <pre class="log-content-pre">{{ row.content }}</pre>
            </template>
          </ele-pro-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('maintenance.dataClean')" name="clean">
          <div class="clean-panel">
            <el-form
              :model="form"
              label-width="90px"
              class="ele-form-search"
              @submit.native.prevent>
              <el-form-item :label="$t('cleandata.selecttime')">
                <el-date-picker
                  v-model="form.time"
                  type="datetimerange"
                  range-separator="~"
                  :start-placeholder="$t('cleandata.startingtime')"
                  :end-placeholder="$t('cleandata.endtime')"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%;"/>
              </el-form-item>
              <el-form-item :label="$t('cleandata.selectdata')">
                <el-select
                  v-model="form.table"
                  clearable
                  placeholder="请选择"
                  style="width: 100%;">
                  <el-option
                    v-for="item in cleanScopeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
              <div class="danger-tip">{{ $t('cleandata.warnings') }}</div>
              <el-form-item>
                <el-button type="danger" :loading="loading" @click="cleanData">
                  {{ $t('cleandata.recognize') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';

export default {
  name: 'ConfigMaintenance',
  data() {
    return {
      active: 'log',
      logUrl: '/errorlog/index',
      paymentLogUrl: '/errorlog/paymentLog',
      form: {},
      loading: false,
      logClearing: false,
      paymentLogClearing: false,
      cleanScopeOptions: []
    };
  },
  mounted() {
    loadDictOptions('clean_data_scope')
      .then((list) => { this.cleanScopeOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  computed: {
    logColumns() {
      return [
        {
          prop: 'log_time',
          label: this.$t('maintenance.logTime'),
          width: 200,
          showOverflowTooltip: true
        },
        {
          prop: 'file',
          label: this.$t('maintenance.logFile'),
          width: 220,
          showOverflowTooltip: true
        },
        {
          prop: 'content',
          label: this.$t('maintenance.logContent'),
          minWidth: 400,
          slot: 'content'
        }
      ];
    }
  },
  methods: {
    clearLogs(type) {
      const isPayment = type === 'payment';
      const confirmText = isPayment
        ? this.$t('maintenance.clearPaymentLogConfirm')
        : this.$t('maintenance.clearLogConfirm');
      const url = isPayment ? '/errorlog/clearPayment' : '/errorlog/clear';
      const tableRef = isPayment ? 'paymentLogTable' : 'logTable';
      const loadingKey = isPayment ? 'paymentLogClearing' : 'logClearing';

      this.$confirm(confirmText, this.$t('cleandata.confirmTitle'), {
        type: 'warning',
        confirmButtonText: this.$t('cleandata.confirmDelete'),
        cancelButtonText: this.$t('universal.cancel')
      }).then(() => {
        this[loadingKey] = true;
        this.$http.post(url).then(res => {
          this[loadingKey] = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.$refs[tableRef].reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          this[loadingKey] = false;
          this.$message.error(e.message);
        });
      }).catch(() => {
      });
    },
    cleanData() {
      this.$confirm(this.$t('cleandata.warnings'), this.$t('cleandata.confirmTitle'), {
        type: 'warning',
        confirmButtonText: this.$t('cleandata.confirmDelete'),
        cancelButtonText: this.$t('universal.cancel')
      }).then(() => {
        this.loading = true;
        this.$http.post('/configweb/deleteshuju', this.form).then(res => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          this.loading = false;
          this.$message.error(e.message);
        });
      }).catch(() => {
      });
    }
  }
};
</script>

<style scoped>
.clean-panel {
  max-width: 560px;
  padding: 16px 0 24px;
}

.danger-tip {
  margin: 0 0 16px 90px;
  color: #f56c6c;
  font-weight: 600;
  line-height: 1.6;
}

.log-content-pre {
  margin: 0;
  padding: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: Consolas, 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.6;
  max-height: 240px;
  overflow: auto;
  background: transparent;
  border: none;
}
</style>
